export { version } from './src/package.js'
import { dispatch } from './src/event.js'

if (typeof jQuery != 'undefined') {
  jQuery.extend(jQuery.fn, {
    dispatch: dispatch
  })
}
